// Aliases

export const EXTERNAL_VALUATION_SPREADSHEET_HEADER_TITLE = 'EXTERNAL_VALUATION_SPREADSHEET_HEADER_TITLE';
export const EXTERNAL_VALUATION_SPREADSHEET_ENTERPRISE_VALUE = 'EXTERNAL_VALUATION_SPREADSHEET_ENTERPRISE_VALUE';
export const EXTERNAL_VALUATION_SPREADSHEET_EQUITY_VALUE = 'EXTERNAL_VALUATION_SPREADSHEET_EQUITY_VALUE';
export const EXTERNAL_VALUATION_SPREADSHEET_HEADER_TITLE_ROW_NUMBER = 1;
export const EXTERNAL_VALUATION_SPREADSHEET_ENTERPRISE_VALUE_ROW_NUMBER = 2;
export const EXTERNAL_VALUATION_SPREADSHEET_EQUITY_VALUE_ROW_NUMBER = 3;
